<template>
  <div class="row mt-2 mt-md-4 mt-lg-5">
    <div class="col-12 col-md-10 mx-auto">
      <form>
        <slot />

        <Stepper />
      </form>
    </div>
  </div>
</template>

<script>
import Stepper from './Stepper.vue';

export default {
  name: 'StepForm',

  components: {
    Stepper,
  },
};
</script>
